export default "__VITE_ASSET__1qNKl8ee__ 430w";